import NoDataIcon from 'assets/icons/NoData.svg'
import GreenCheckIcon from 'assets/icons/GreenCheck.svg'
import CheckboxIconGreen from 'assets/icons/CheckboxIconGreen.svg'
import CheckboxIconBlue from 'assets/icons/CheckboxIconBlue.svg'
import CheckboxOutline from 'assets/icons/CheckboxOutline.svg'

interface IProps {
  name: string
  width?: number
  height?: number
  className?: string
}

const IMAGES: any = {
  NoDataIcon,
  GreenCheckIcon,
  CheckboxIconGreen,
  CheckboxIconBlue,
  CheckboxOutline
}

export function SvgImage({ name, width = 0, height = 0, className }: IProps): JSX.Element {
  return (
    <img
      src={IMAGES[name]}
      width={width}
      height={height}
      className={className}
      alt="SVG"
      color=''
    />
  )
}
